import React from 'react';
import PolicyCertficateMedicalGroupSummaryDialog from './PolicyCertficateMedicalGroupSummaryDialog';
import { Production_CertificateDetailsOutputInput } from '../medical-certificate-drawer';
import EnhancedModal from '@components/generic-modal/EnhancedModal';
import { IAbstractRecord } from '@models';

interface IPolicyCertficateMedicalGroupSummaryDialogShellProps {
  data: Production_CertificateDetailsOutputInput;
  entityId: string;
  planDetails: IAbstractRecord;
  onClose: () => void;
  onSuccess: () => void;
}

const PolicyCertficateMedicalGroupSummaryDialogShell: React.FC<
  IPolicyCertficateMedicalGroupSummaryDialogShellProps
> = ({ data, entityId, planDetails, onClose = () => undefined, onSuccess }) => {
  return (
    <EnhancedModal
      onClose={onClose}
      open={true}
      blur={true}
      title={'Add Certificate'}
    >
      <PolicyCertficateMedicalGroupSummaryDialog
        data={data}
        planDetails={planDetails}
        entityId={entityId}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </EnhancedModal>
  );
};

export default PolicyCertficateMedicalGroupSummaryDialogShell;
